export default "__VITE_ASSET__CaHRZOXC__"